import { useEffect } from "react";
import { Input } from "@remo-co/ui-core/src/components/Input";
import { Tooltip } from "@remo-co/ui-core/src/components/Tooltip";
import clamp from "lodash/clamp";
import { useSelector } from "react-redux";
import { useI18n } from "i18n";
import {
  DEFAULT_SHUFFLE_GROUP_SIZE,
  DEFAULT_MIN_SHUFFLE_GROUP_SIZE,
} from "modules/shuffleAttendees/constants";
import { selectMaxUsersPerTable } from "./selectors";

interface Props {
  setTargetGroupSize: (targetGroupSize: number | null) => void;
  targetGroupSize: number | null;
}

export const ShuffleGroupSize = ({
  setTargetGroupSize,
  targetGroupSize,
}: Props) => {
  const maxGroupSize = useSelector(selectMaxUsersPerTable);
  const { t } = useI18n(["event"]);

  useEffect(() => {
    setTargetGroupSize(
      clamp(
        DEFAULT_SHUFFLE_GROUP_SIZE,
        DEFAULT_MIN_SHUFFLE_GROUP_SIZE,
        maxGroupSize,
      ),
    );
  }, [maxGroupSize, setTargetGroupSize]);

  return (
    <Tooltip
      title={t("event:shuffle.target.group.size.tooltip")}
      disableInteractive
    >
      <Input
        type="number"
        value={targetGroupSize ?? undefined}
        inputProps={{
          min: DEFAULT_MIN_SHUFFLE_GROUP_SIZE,
          max: maxGroupSize,
          "data-testid": "target-group-size-input",
        }}
        onChange={(ev) => {
          const newTargetGroupSize = parseInt(ev.target.value, 10);

          if (Number.isNaN(newTargetGroupSize)) {
            setTargetGroupSize(null);
          } else {
            setTargetGroupSize(
              clamp(
                newTargetGroupSize,
                DEFAULT_MIN_SHUFFLE_GROUP_SIZE,
                maxGroupSize,
              ),
            );
          }
        }}
      />
    </Tooltip>
  );
};
